import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Does Arvo work offline?",
    a: "Yes. Sessions run entirely on your phone in the yard, so coverage drops don't stop you. Data isn't synced anywhere — your sessions are immediately available for export the moment you're back in coverage.",
  },
  {
    q: "Can I use my current EID reader?",
    a: "Yes. Arvo runs in dual mode — pair your existing EID reader for fast scanning, or fall back to manual entry on the days that call for it.",
  },
  {
    q: "Is training required to onboard new staff?",
    a: "Most users are productive within 10 minutes. The workflow follows yard logic — big buttons, plain words, no manual to read. New hands can pick it up between mobs.",
  },
  {
    q: "Where does my animal data come from?",
    a: "You bring your own. Animal IDs can be imported from your herd records and/or NAIT records as a CSV — Arvo is independent and provider-neutral. Need a hand setting things up? Email our support desk at support@getarvo.co.nz.",
  },
  {
    q: "Does Arvo send my data anywhere?",
    a: "No. Arvo is your tool for capturing and reviewing your own records on-farm. You stay in control — when you're ready to share results (with your herd record provider, vet, livestock representative or office), you export the CSV from your phone.",
  },
];

export default function FAQSection() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="bg-[#F9F8F6] py-20 md:py-28"
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <span className="inline-block text-xs font-bold tracking-[0.2em] uppercase text-[#D96C32]">
            Common Questions
          </span>
          <h2
            data-testid="faq-headline"
            className="mt-4 font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-[#1A1D1A] leading-tight"
          >
            Quick answers, no jargon.
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-12 space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-white border border-[#D5D1C8] rounded-md px-5 sm:px-6 shadow-sm data-[state=open]:border-[#2D4A22] transition-colors"
            >
              <AccordionTrigger className="text-left font-display font-bold text-base sm:text-lg text-[#1A1D1A] hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-base text-[#4A4F4A] leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
